export const deliverOrderDetail = {
  saveImage: 'n.3390.6083.0', // 保存图片
  shareDetail: 'n.3390.6726.0' // 详情页点击发送给同事（分享按钮）
}
